import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  public url: string;

  constructor(private http: HttpClient) {
    this.url = environment.APIEndpoint;
  }

  request(path: string, params: any): Promise<any> {
    const apiUrl = `${this.url}${path}`;

    return new Promise((resolve, reject) => {
      this.http.post(apiUrl, params, { withCredentials: true }).subscribe(
        async (res: any) => {
          resolve(res);
        },
        async (error) => {
          reject(error);
        }
      );
    });
  }

  requestBlob(path: string, params: any): Promise<Blob> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${this.url}${path}`, params, {
          withCredentials: true,
          responseType: 'blob',
        })
        .subscribe({ next: resolve, error: reject });
    });
  }
}
